module.exports = __webpack_public_path__ + "static/media/icon-cart.fb4287b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/home-navbar/cart-button/icon-cart.svg
// module id = 392
// module chunks = 0 1 2